import { Box, Grid, Typography } from '@mui/material';
import { styles } from '../../styles';
import Image from 'next/image';

const BlankScreenContainer = ({ onclick, isMobile }: any) => {
  return (
    <Grid
      container
      padding={0}
      rowGap={0}
      marginBottom={isMobile ? 0 : '2rem'}
      marginTop={'0.5rem'}
      width={'100%'}
      columnGap={isMobile ? 0 : 2.5}
      display={'flex'}
      flexDirection={'column'}
      justifyContent={'flex-start'}
      sx={{ maxHeight: '100vh', overflowY: 'auto' }}>
      {isMobile && (
        <Box
          onClick={onclick}
          border={'1px dotted #0072CE'}
          borderRadius={'0.75rem'}
          width={isMobile ? '16rem' : '294px'}
          height={isMobile ? '330px' : '330px'}
          display='flex'
          flexDirection='column'
          alignItems='center'
          justifyContent='center'
          textAlign='center'
          gap='0.5rem'
          padding='1rem'
          sx={{
            cursor: 'pointer',
            margin: isMobile ? 'auto' : 'unset',
            position: isMobile ? 'absolute' : 'unset',
            top: isMobile ? '50%' : 'unset',
            left: isMobile ? '50%' : 'unset',
            transform: isMobile ? 'translate(-50%, -50%)' : 'unset',
            marginTop: '90px',
          }}>
          {/* Icon/Image */}
          <Image priority src={'/images/logo-new.svg'} alt={'Empty Screen'} width={66} height={34} />

          {/* Text */}
          <Typography color='#2D3748' fontSize={isMobile ? '1.1rem' : '0.9rem'} fontWeight='500'>
            Let’s create your first Memvy!
          </Typography>
        </Box>
      )}
      <Grid
        paddingRight={isMobile ? '2rem' : 0}
        gap={'0.75rem'}
        display={'flex'}
        width={'100%'}
        flexDirection={'column'}>
        <Grid
          item
          display={'flex'}
          sx={styles.container}
          padding={isMobile ? '0.5rem 0' : '1rem 0'}
          flexDirection={'column'}>
          <Grid
            xs={1}
            borderRadius={'0.75rem'}
            onClick={onclick}
            bgcolor={'transparent'}
            minHeight={isMobile ? '14.913rem' : '20.375rem'}
            minWidth={isMobile ? '10rem' : '16.625rem'}
            maxHeight={isMobile ? '14.913rem' : '20.375rem'}
            maxWidth={isMobile ? '10rem' : '16.625rem'}
            position={'relative'}>
            {!isMobile && (
              <Box
                onClick={onclick}
                border={'3px dotted #0072CE'}
                borderRadius={'0.75rem'}
                width={isMobile ? '16rem' : '294px'}
                height={isMobile ? '330px' : '330px'}
                display='flex'
                flexDirection='column'
                alignItems='center'
                justifyContent='center'
                textAlign='center'
                gap='0.5rem'
                padding='1rem'
                sx={{
                  cursor: 'pointer',
                  margin: isMobile ? 'auto' : 'unset',
                  position: isMobile ? 'absolute' : 'unset',
                  top: isMobile ? '50%' : 'unset',
                  left: isMobile ? '50%' : 'unset',
                  transform: isMobile ? 'translate(-50%, -50%)' : 'unset',
                }}>
                {/* Icon/Image */}
                <Image priority src={'/images/logo-new.svg'} alt={'Empty Screen'} width={66} height={34} />

                {/* Text */}
                <Typography
                  color='#2D3748'
                  fontSize={isMobile ? '20px' : '20px'}
                  fontWeight='500'
                  sx={{ maxWidth: '160px', wordWrap: 'break-word', lineHeight: '1.3' }}>
                  Let’s create your first Memvy!
                </Typography>
              </Box>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default BlankScreenContainer;
